module.exports = __webpack_public_path__ + "img/index-about-develop.8b6a7862.png";